import React, { useRef, useState, useEffect } from 'react';

const isInRange = (WrappedComponent, offset = 1) => {
  const handles = [];

  const IsInRangeContainer = (props) => {
    const viewport = useRef();
    const [isInRange, setIsInrange] = useState(false);

    const getBoundingClientRect = () => {
      return viewport.current.getBoundingClientRect();
    };

    const isComponentWithinRange = () => {
      if (!viewport.current) return;

      const rect = getBoundingClientRect();
      if (rect.top < offset && rect.bottom > 0) {
        !isInRange && setIsInrange(true);
      } else {
        isInRange && setIsInrange(false);
      }
    };

    useEffect(() => {
      handles.push(isComponentWithinRange);
    }, [isInRange]);

    return (
      <div ref={viewport}>
        <WrappedComponent {...props} isInRange={isInRange} offset={offset} />
      </div>
    );
  };

  let ticking = false;
  const throttleScroll = () => {
    ticking =
      ticking ||
      requestAnimationFrame(() => {
        ticking = false;
        handles.map((handle) => handle());
      });
  };

  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', throttleScroll, false);
    window.addEventListener('resize', throttleScroll, false);
  }

  return IsInRangeContainer;
};

export default isInRange;